<template>
  <div>
    <section
      :class="$style.sectionRoot"
    >
      <header :class="$style.sectionHeader">
        {{ getHeader }}
      </header>
      <div :class="$style.sectionContent">
        <InputValidator
          :config="{
            attribute: 'name',
            label: `${configurationItem.title} Name`,
            name: 'name',
            validate: 'required',
            value: item.name,
          }"
          @InputValidatorModel="handleNameChange"
        />
        <label
          :class="[
            $style['label-font'],
            $style['label-color'],
            $style['label-typography'],
          ]"
        >{{ configurationItem.title }} Description</label>
        <!-- DO NOT ALLOW ANY USER INPUT IN STRING PASSED TO v-html -->
        <!-- eslint-disable-next-line vue/no-v-html -->
        <p v-html="item.template.description" />
        <div
          v-if="item.name === 'FileVault 2'"
          :class="$style.fileVaultLink"
        >
          <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" :class="$style.playIcon" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M8 14.423c1.154 0 2.23-.295 3.23-.885a6.228 6.228 0 002.308-2.307c.59-1 .885-2.077.885-3.231s-.295-2.23-.885-3.23a6.228 6.228 0 00-2.307-2.308c-1-.59-2.077-.885-3.231-.885s-2.23.295-3.23.885a6.228 6.228 0 00-2.308 2.307c-.59 1-.885 2.077-.885 3.231s.295 2.23.885 3.23a6.228 6.228 0 002.307 2.308c1 .59 2.077.885 3.231.885zM8 0c1.462 0 2.814.365 4.058 1.096a7.582 7.582 0 012.846 2.846A7.868 7.868 0 0116 8a7.868 7.868 0 01-1.096 4.058 7.582 7.582 0 01-2.846 2.846A7.868 7.868 0 018 16a7.868 7.868 0 01-4.058-1.096 7.726 7.726 0 01-2.846-2.866A7.833 7.833 0 010 8c0-1.449.365-2.795 1.096-4.038a7.873 7.873 0 012.866-2.866A7.833 7.833 0 018 0zM6.385 11.596V4.385L11.192 8l-4.807 3.596z" fill="#8A94A6" fill-rule="nonzero"/></svg>
          <ButtonLink
            text="Watch Video Tutorial"
            @click="showModal"
          />
        </div>
        <label
          :class="[
            $style['label-font'],
            $style['label-color'],
            $style['label-typography'],
          ]"
        >{{ configurationItem.title }} Behavior</label>
        <p>{{ item.template.behavior }}</p>
        <label
          :class="[
            $style['label-font'],
            $style['label-color'],
            $style['label-typography'],
          ]"
        >{{ configurationItem.title }} Activation</label>
        <p>{{ item.template.activation }}</p>
      </div>
    </section>
  </div>
</template>
<script>
import { PolicyConsts } from 'client/util/Constants';
import { startCase } from 'lodash';
import AsidePanelChildComponentMethodsMixin from 'client/components/AsidePanel/mixins/AsidePanelChildComponentMethodsMixin';
import AsidePanelChildComponentPropsMixin from 'client/components/AsidePanel/mixins/AsidePanelChildComponentPropsMixin';
import ButtonLink from 'client/components/Buttons/ButtonLink.vue';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import InputValidator from 'client/components/FormValidation/InputValidator.vue';
import ItemType from 'client/util/Constants/ItemType';
import ModalEventBus from 'client/components/Modal/ModalEventBus';
import VideoModal from 'client/components/Modal/VideoModal.vue';

const { ConfigurationItemType } = ItemType;
const { fileVaultIframeTutorialVideoUrl, fileVaultTutorialVideoUrl } = PolicyConsts;

export default {
  name: 'ConfigurationDescription',

  inject: ['$validator'],

  components: {
    ButtonLink,
    InputValidator,
  },

  mixins: [
    AsidePanelChildComponentMethodsMixin,
    AsidePanelChildComponentPropsMixin,
  ],

  data: () => ({
    configurationItem: new ConfigurationItemType(),
  }),

  computed: {
    getHeader() {
      if (this.item && this.item.template) {
        const os = PolicyConsts.policyTemplateDisplayValues[this.item.template.osMetaFamily];
        return `${os === PolicyConsts.policyTemplateTypes.ios ? 'iOS' : startCase(os)} - ${this.item.template.displayName} ${this.configurationItem.title}`;
      }
      return '';
    },
  },

  beforeCreate() {
    this.$options.methods.asidePanelChildComponentHandleBeforeCreate(this.$options);
  },

  methods: {
    handleNameChange(value, key) {
      this.setItemField({ key, value });
    },
    showModal() {
      EventHelper.triggerLinkClicked({
        description: 'Launches video modal for FileVault',
        location: 'Mac FileVault 2 Policy Aside',
        text: 'Watch Video Tutorial',
      });
      ModalEventBus.open({
        component: VideoModal,
        isLargeModal: true,
        componentProps: {
          header: 'FileVault',
          videos: [
            {
              iframeUrl: fileVaultIframeTutorialVideoUrl,
              videoUrl: fileVaultTutorialVideoUrl,
            },
          ],
        },
      });
    },
  },
};
</script>
<style module>
@import '../../css/sections.css';
@import '../../components/FormValidation/css/formFields.css';

.playIcon {
  height: 1em;
  width: 1em;
}

.fileVaultLink {
  margin-bottom: 1rem;
}
</style>
